import React from 'react';
import { Tab as HeadlessTab } from '@headlessui/react';
import cn from 'classnames';

import styles from './tab.module.scss';
import { withClassName } from '@crocodille/common';

const PanelElement: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return (
    <HeadlessTab.Panel className={cn(styles.panel)}>
      {children}
    </HeadlessTab.Panel>
  );
};

const TabElement: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return (
    <HeadlessTab as={React.Fragment}>
      {({ selected }) => (
        <button className={cn(styles.tab, { [styles.isSelected]: selected })}>
          {children}
        </button>
      )}
    </HeadlessTab>
  );
};

const Tab = Object.assign(TabElement, {
  List: withClassName(HeadlessTab.List, styles.list),
  Panels: HeadlessTab.Panels,
  Group: HeadlessTab.Group,
  Panel: PanelElement,
});

export default Tab;
